import React, { useState, useEffect } from 'react';
import './AnalystScheduler.css';
import Button from "../../../components/atoms/button/Button";
import CloseIcon from '../../../components/Assests/Close-Icon.png';
import { toast } from 'react-toastify';
import CalanderIcon from '../../../components/Assests/Calander-Icon.png';
import CloseVector from '../../../components/Assests/Close-Vector.png';
import { ToastContainer } from 'react-toastify';
import {
  getSchedulerSummary,
  getAnalystAssignedSamples,
  getProductSamples,
  unassignSamples,
  assignSamples,
  getAssignedProductsCount,
  getSamplesForRemove,
} from '../../Lab Admin Tabs/Scheduler/SchedularApi';
import SecondTab from '../../../components/organisms/secondTab';

const parseDateStringToUTC = (dateString) => {
  if (!dateString) return null;
  const [y, m, d] = dateString.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d));
};

const formatDateToInputUTC = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatDateToInput = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatDateDDMMYY = (dateString) => {
  if (!dateString) return '';

  const datePart = dateString.split('T')[0];
  const [year, month, day] = datePart.split('-');

  return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${String(year).slice(-2)}`;
};

const formatDateForDisplay = (dateString) => {
  if (!dateString) return '';
  const [year, month, day] = dateString.split('-');
  return `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${String(year).slice(-2)}`;
};

const getNearestSunday = (date = new Date()) => {
  const d = new Date(date);
  const day = d.getDay();
  d.setDate(d.getDate() - day);
  return d;
};

const createLocalDate = (dateString) => {
  const [year, month, day] = dateString.split('-');
  return new Date(year, month - 1, day, 0, 0, 0);
};

const parseApiDate = (apiDateString) => {
  const datePart = apiDateString.split('T')[0];
  return datePart;
};

const parseProductsAssigned = (productsArray) => {
  if (!Array.isArray(productsArray)) return [];
  return productsArray.map((item) => {
    const match = item.match(/^(.+)\((\d+)\)$/);
    return {
      productTypeName: match ? match[1] : item,
      name: match ? match[1] : item,
      count: match ? parseInt(match[2]) : 0,
      productCount: match ? parseInt(match[2]) : 0,
      displayText: item,
      productWithSampleCount: item,
    };
  });
};

const getCurrentUser = () => {
  try {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const parsed = JSON.parse(userData);
      return {
        name: parsed.name,
        email: parsed.email,
        userID: parsed.userID,
        id: parsed.userID,
      };
    }
    return null;
  } catch {
    return null;
  }
};

const getTodayDateString = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const AnalystScheduler = ({ TabConfig }) => {
  useEffect(() => {
    document.body.classList.add('analyst-scheduler-active');
    return () => {
      document.body.classList.remove('analyst-scheduler-active');
    };
  }, []);

  const initialSunday = formatDateToInput(getNearestSunday());
  const [fromDate, setFromDate] = useState(initialSunday);
  const [toDate, setToDate] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteTaskInfo, setDeleteTaskInfo] = useState({ task: '', analyst: '', day: '', sampleIds: [] });
  const [selectedAnalyst, setSelectedAnalyst] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedSamples, setSelectedSamples] = useState([]);
  const [currentSampleList, setCurrentSampleList] = useState([]);
  const [scheduleData, setScheduleData] = useState([]);
  const [assignedProductsFromSchedule, setAssignedProductsFromSchedule] = useState([]);
  const [analysts, setAnalysts] = useState([]);
  const [productSamples, setProductSamples] = useState([]);
  const [productSamplesLoading, setProductSamplesLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [assignedProductsLoading, setAssignedProductsLoading] = useState(false);
  const [samplesForRemove, setSamplesForRemove] = useState([]);
  const [selectedSamplesToDelete, setSelectedSamplesToDelete] = useState([]);

  useEffect(() => {
    if (showPopup) {
      try {
        const userData = localStorage.getItem('userData');
        if (userData) {
          const userID = JSON.parse(userData).userID;
          const userName = JSON.parse(userData).name;

          let matchedAnalyst = analysts.find(
            (a) => String(a.userID || a.userId || a.id) === String(userID)
          );

          if (!matchedAnalyst && userName) {
            matchedAnalyst = analysts.find((a) => {
              const analystName = (
                a.fullName ||
                a.name ||
                a.userName ||
                ''
              ).trim();
              return analystName.toLowerCase() === userName.toLowerCase();
            });
          }

          if (!matchedAnalyst && userID && userName) {
            const tempAnalyst = {
              userID: userID,
              userId: userID,
              id: userID,
              fullName: userName,
              name: userName,
              userName: userName,
            };

            setAnalysts((prev) => [...prev, tempAnalyst]);
            setSelectedAnalyst(String(userID));
          } else if (matchedAnalyst) {
            setSelectedAnalyst(
              String(
                matchedAnalyst.userID ||
                matchedAnalyst.userId ||
                matchedAnalyst.id
              )
            );
          }
        }
      } catch (error) {
        console.error('Auto-selection error:', error);
      }
    }
  }, [showPopup, analysts]);

  useEffect(() => {
    if (!fromDate) return;
    const from = new Date(fromDate);
    const toDateCalculated = new Date(from);
    toDateCalculated.setDate(toDateCalculated.getDate() + 13);
    setToDate(formatDateToInput(toDateCalculated));
  }, [fromDate]);

  useEffect(() => {
    if (selectedProduct && selectedAnalyst && selectedDate) {
      const fetchAssignedProductsCount = async () => {
        setAssignedProductsLoading(true);
        try {
          const analystObj = analysts.find(
            (a) =>
              String(a.userID || a.userId || a.id) === String(selectedAnalyst)
          );

          if (!analystObj) {
            console.error('Analyst not found for ID:', selectedAnalyst);
            setAssignedProductsFromSchedule([]);
            return;
          }

          const analystName =
            analystObj.fullName || analystObj.name || analystObj.userName;

          const result = await getAssignedProductsCount(
            analystName,
            selectedDate
          );

          if (
            result?.productsassigned &&
            Array.isArray(result.productsassigned)
          ) {
            const mappedProducts = parseProductsAssigned(
              result.productsassigned
            );
            setAssignedProductsFromSchedule(mappedProducts);
          } else if (Array.isArray(result) && result.length > 0) {
            setAssignedProductsFromSchedule(result);
          } else {
            setAssignedProductsFromSchedule([]);
          }
        } catch (error) {
          console.error('Error fetching assigned products:', error);
          setAssignedProductsFromSchedule([]);
        } finally {
          setAssignedProductsLoading(false);
        }
      };
      fetchAssignedProductsCount();
    } else {
      setAssignedProductsFromSchedule([]);
      setAssignedProductsLoading(false);
    }
  }, [selectedProduct, selectedAnalyst, selectedDate, analysts]);

  useEffect(() => {
    const initializeData = async () => {
      setIsLoading(true);
      try {
        const nearestSunday = getNearestSunday(new Date());
        const calculatedFromDate = formatDateToInput(nearestSunday);
        const calculatedToDate = formatDateToInput(
          new Date(nearestSunday.getTime() + 13 * 86400000)
        );
        setFromDate(calculatedFromDate);
        setToDate(calculatedToDate);
        setCurrentSampleList([]);
        const [summaryData, assignedData] = await Promise.all([
          getSchedulerSummary(),
          getAnalystAssignedSamples({
            fromDate: calculatedFromDate,
            toDate: calculatedToDate,
          }),
        ]);
        const mappedSummary = (summaryData?.data || summaryData || []).map(
          (item, index) => ({
            id: item.id || item.productTypeId || `summary-${index}`,
            name: `${item.productTypeName || item.productName} (${item.productCount
              })`,
            assayCount: item.assayCount || 0,
            reAssay1Count: item.reAssay1Count || 0,
            reAssay2Count: item.reAssay2Count || 0,
            status: item.status || (item.productCount > 10 ? 'green' : 'red'),
          })
        );
        setCurrentSampleList(mappedSummary);
        const extractedAnalysts = [];
        if (Array.isArray(assignedData)) {
          assignedData.forEach((data) => {
            if (data.analyst) {
              const existingAnalyst = extractedAnalysts.find(
                (a) => a.fullName === data.analyst
              );
              if (!existingAnalyst) {
                extractedAnalysts.push({
                  fullName: data.analyst,
                  userID: data.userID,
                  userId: data.userId,
                  id: data.userID,
                  name: data.analyst,
                  userName: data.analyst,
                });
              }
            }
          });
        }
        setAnalysts(extractedAnalysts);
        if (Array.isArray(assignedData)) {
          const scheduleDataWithAssignments = extractedAnalysts.map(
            (analyst) => {
              const analystName =
                analyst.fullName || analyst.name || analyst.userName;
              const analystId = analyst.userId || analyst.userID || analyst.id;
              const analystSchedule = { analyst: analystName, analystId };
              const assignedDataForAnalyst = assignedData.find((data) => {
                if (!data.analyst || !analystName) return false;
                const apiAnalyst = data.analyst.toLowerCase().trim();
                const currentAnalyst = analystName.toLowerCase().trim();
                const isMatch = apiAnalyst === currentAnalyst;
                return isMatch;
              });
              if (assignedDataForAnalyst?.receiveddates) {
                assignedDataForAnalyst.receiveddates.forEach((dateData) => {
                  if (!dateData.receivedDate) return;
                  const dateKey = parseApiDate(dateData.receivedDate);
                  if (dateData.schedulerSamplesProDuctsDto?.length > 0) {
                    analystSchedule[dateKey] = {
                      products: dateData.schedulerSamplesProDuctsDto.map(
                        (product) => ({
                          name: product.productTypeName,
                          count: product.samplesCount,
                          productCount: product.productCount,
                          sampleIds: product.sampleIds,
                          displayText: product.productWithSampleCount,
                        })
                      ),
                    };
                  }
                });
              }
              return analystSchedule;
            }
          );
          setScheduleData(scheduleDataWithAssignments);
        } else {
          setScheduleData([]);
        }
        setHasSearched(true);
      } catch {
        setAnalysts([]);
        setCurrentSampleList([]);
        setScheduleData([]);
        setHasSearched(true);
      }
      setIsLoading(false);
    };
    initializeData();
  }, []);

  useEffect(() => {
    if (fromDate && toDate && hasSearched) {
      handleSearch();
    }
  }, [fromDate, toDate]);

  const fetchCurrentSamples = async () => {
    try {
      setCurrentSampleList([]);
      const summary = await getSchedulerSummary();
      const mapped = (summary?.data || summary || []).map((item, index) => ({
        id: item.id || item.productTypeId || `summary-${index}`,
        name: `${item.productTypeName || item.productName} (${item.productCount
          })`,
        assayCount: item.assayCount || 0,
        reAssay1Count: item.reAssay1Count || 0,
        reAssay2Count: item.reAssay2Count || 0,
        status: item.status || (item.productCount > 10 ? 'green' : 'red'),
      }));
      setCurrentSampleList(mapped);
    } catch {
      setCurrentSampleList([]);
    }
  };

  const generateDateHeaders = () => {
    const startDate = new Date(fromDate);
    const endDate = new Date(toDate);
    const dateHeaders = [];

    const startSunday = new Date(startDate);
    const dayOfWeek = startDate.getDay();
    startSunday.setDate(startDate.getDate() - dayOfWeek);

    let currentDate = new Date(startSunday);

    while (currentDate <= endDate) {
      const dayName = currentDate.toLocaleDateString('en-US', {
        weekday: 'short',
      });
      const dateStr = currentDate.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
      });
      const yyyyMMdd = currentDate.toLocaleDateString('en-US').substring(0, 10);
      const newdate = yyyyMMdd.split("/");
      dateHeaders.push({
        label: `${dayName}, ${dateStr}`,
        date: new Date(currentDate),
        key: `${newdate[2]}-${newdate[0].padStart(2, "0")}-${newdate[1].padStart(2, "0")}`,
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateHeaders;
  };

  const dateHeaders = generateDateHeaders();
  const week1Dates = dateHeaders.slice(0, 7);
  const week2Dates = dateHeaders.slice(7, 14);

  const handleDeleteClick = async (task, analyst, day, sampleIds) => {
    try {
      const samplesData = await getSamplesForRemove(sampleIds);
      setSamplesForRemove(samplesData);
      setDeleteTaskInfo({ task, analyst, day, sampleIds });
      setSelectedSamplesToDelete(sampleIds || []);
      setShowDeleteConfirm(true);
    } catch (error) {
      console.error('Error fetching samples for remove:', error);
      toast.error('Failed to fetch sample details');
    }
  };

  const openSamplePopup = async (sample) => {
    setSelectedProduct(sample);
    setShowPopup(true);
    setProductSamplesLoading(true);
    setSelectedSamples([]);
    setAssignedProductsFromSchedule([]);
    setSelectedAnalyst("");
    setSelectedDate("");
    try {
      const productTypeName = sample.name.split("(")[0].trim();
      const data = await getProductSamples(productTypeName);
      setProductSamples(data || []);
    } catch (err) { setProductSamples([]); }
    finally { setProductSamplesLoading(false); }
  };

  const handleConfirmDelete = async () => {
    const { task, analyst } = deleteTaskInfo;
    if (!selectedSamplesToDelete || selectedSamplesToDelete.length === 0) {
      toast.error('No samples selected for deletion');
      return;
    }

    try {
      await unassignSamples(selectedSamplesToDelete);
      setShowDeleteConfirm(false);
      setDeleteTaskInfo({ task: '', analyst: '', day: '', sampleIds: [] });
      setSelectedSamplesToDelete([]);
      setSamplesForRemove([]);
      await refreshAllData();
      toast.success(
        `Successfully unassigned ${selectedSamplesToDelete.length} sample(s)`
      );
    } catch (err) {
      console.error('Delete error:', err);
      toast.error('Failed to unassign samples. Please try again.');
    }
  };

  const refreshAllData = async () => {
    try {
      await Promise.all([refreshSchedulerData(), fetchCurrentSamples()]);
    } catch (error) {
      console.error('Error refreshing data:', error);
      toast.error('Failed to refresh page data');
    }
  };

  const handleAssign = async () => {
    if (!selectedSamples.length || !selectedAnalyst || !selectedDate) {
      toast.error('Please select analyst, date and samples');
      return;
    }
    try {
      const analystObj = analysts.find(
        (a) => String(a.userID || a.userId || a.id) === String(selectedAnalyst)
      );

      const analystName = analystObj
        ? analystObj.fullName || analystObj.name || analystObj.userName
        : 'Selected analyst';
      const payload = {
        Analyst: analystName,
        SampleIds: selectedSamples,
        DateToWorkOn: `${selectedDate}T00:00:00`,
      };


      await assignSamples(payload);
      await refreshAllData();
      setShowPopup(false);
      setSelectedSamples([]);
      setSelectedAnalyst('');
      setSelectedDate('');
      setSelectedProduct(null);
      setAssignedProductsFromSchedule([]);
      toast.success(
        `Successfully assigned ${selectedSamples.length} sample(s) to ${analystName} for ${formatDateForDisplay(selectedDate)}`
      );
    } catch (err) {
      const errorMessage =
        err?.response?.data?.errors?.Analyst?.[0] ||
        err?.response?.data?.message ||
        'Failed to assign samples';
      toast.error(errorMessage);
    }
  };

  const refreshSchedulerData = async () => {
    setIsLoading(true);
    try {
      setCurrentSampleList([]);
      const [summaryData, assignedData] = await Promise.all([
        getSchedulerSummary(),
        getAnalystAssignedSamples({
          fromDate: fromDate,
          toDate: toDate,
        }),
      ]);
      const mappedSummary = (summaryData?.data || summaryData || []).map(
        (item, index) => ({
          id: item.id || item.productTypeId || `summary-${index}`,
          name: `${item.productTypeName || item.productName} (${item.productCount})`,
          assayCount: item.assayCount || 0,
          reAssay1Count: item.reAssay1Count || 0,
          reAssay2Count: item.reAssay2Count || 0,
          status: item.status || (item.productCount > 10 ? 'green' : 'red'),
        })
      );
      setCurrentSampleList(mappedSummary);

      if (Array.isArray(assignedData)) {
        const updatedScheduleData = analysts.map((analyst) => {
          const analystName =
            analyst.fullName || analyst.name || analyst.userName;
          const analystId = analyst.userId || analyst.userID || analyst.id;
          const analystSchedule = { analyst: analystName, analystId };
          const assignedDataForAnalyst = assignedData.find((data) => {
            if (!data.analyst || !analystName) return false;
            return (
              data.analyst.toLowerCase().trim() ===
              analystName.toLowerCase().trim()
            );
          });
          if (assignedDataForAnalyst?.receiveddates) {
            assignedDataForAnalyst.receiveddates.forEach((dateData) => {
              if (!dateData.receivedDate) return;
              const dateKey = parseApiDate(dateData.receivedDate);
              if (dateData.schedulerSamplesProDuctsDto?.length > 0) {
                analystSchedule[dateKey] = {
                  products: dateData.schedulerSamplesProDuctsDto.map(
                    (product) => ({
                      name: product.productTypeName,
                      count: product.samplesCount,
                      productCount: product.productCount,
                      sampleIds: product.sampleIds,
                      displayText: product.productWithSampleCount,
                    })
                  ),
                };
              }
            });
          }
          return analystSchedule;
        });
        setScheduleData(updatedScheduleData);
        setHasSearched(true);
      }
    } catch {
      toast.error('Failed to refresh data');
    }
    setIsLoading(false);
  };

  const handleDateSelection = (e) => {
    const selectedDateValue = e.target.value;
    const today = getTodayDateString();

    if (selectedDateValue >= today) {
      setSelectedDate(selectedDateValue);
    } else {
      setSelectedDate("");
      toast.error("Cannot assign samples to past dates. Please select today or a future date.");
    }
  };

  const handleAnalystSelection = (e) => {
    setSelectedAnalyst(e.target.value);
  };

  const handleSearch = async () => {
    setHasSearched(true);
    try {
      await refreshSchedulerData();
    } catch {
      toast.error('Failed to refresh schedule data');
    }
  };

  const handlePopupClose = () => {
    setShowPopup(false);
    setSelectedSamples([]);
    setSelectedAnalyst('');
    setSelectedDate('');
    setSelectedProduct(null);
    setAssignedProductsFromSchedule([]);
  };

  const renderWeekSchedule = (weekDates, weekTitle) => {
    return (
      <div className="analyst-scheduler-week-section">
        <div className="analyst-scheduler-week-title">{weekTitle}</div>
        <div className="analyst-scheduler-schedule-grid">
          <div className="analyst-scheduler-header-row">
            {weekDates.map((dateHeader, index) => (
              <div
                key={`${weekTitle}-date-${index}`}
                className="analyst-scheduler-date-header"
              >
                {dateHeader.label}
              </div>
            ))}
          </div>
          {scheduleData.length > 0 &&
            scheduleData.slice(0, 1).map((row, index) => {
              return (
                <div
                  key={`${weekTitle}-analyst-${row.analystId || index}`}
                  className="analyst-scheduler-schedule-row"
                >
                  {weekDates.map((dateHeader, dateIndex) => {
                    const cell = row[dateHeader.key];
                    return (
                      <div
                        key={`${weekTitle}-${row.analystId || index}-${dateHeader.key}`}
                        className="analyst-scheduler-schedule-grid-box"
                      >
                        <div className="analyst-scheduler-task-tags-container">
                          {hasSearched && cell?.products?.map((product, idx) => (
                            <div
                              key={`${weekTitle}-${product.name}-${idx}-${dateHeader.key}`}
                              className="analyst-scheduler-task-tag"
                              title={`${product.name}(${product.count || product.productCount})`}
                            >
                              <span className="analyst-scheduler-task-tag-text">
                                {product.name}({product.count || product.productCount})
                              </span>
                              <button
                                className="analyst-scheduler-close-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteClick(
                                    product.name,
                                    row.analyst,
                                    dateHeader.key,
                                    product.sampleIds
                                  );
                                }}
                              >
                                <img
                                  src={CloseVector}
                                  alt="Close"
                                  className="analyst-scheduler-close-button-image"
                                />
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
        </div>
      </div>
    );
  };

  return (
    <div>
      <SecondTab tabConfig={TabConfig} />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="analyst-scheduler-container">
        <div className="analyst-scheduler-header-controls">
          <div className="analyst-scheduler-header-controls-left">
            <div className="analyst-scheduler-date-input-group">
              <label className="analyst-scheduler-date-label from">From</label>
              <div className="analyst-scheduler-date-input-wrapper">
                <input
                  type="text"
                  value={formatDateForDisplay(fromDate)}
                  readOnly
                  className="analyst-scheduler-date-input-display"
                />
                <img
                  src={CalanderIcon}
                  alt="Calendar"
                  className="analyst-scheduler-calendar-icon"
                />
                <input
                  type="date"
                  value={selectedDate}
                  onChange={handleDateSelection}
                  className="analyst-scheduler-date-input-hidden"
                  min={getTodayDateString()}
                />
              </div>
            </div>
            <div className="analyst-scheduler-date-input-group">
              <label className="analyst-scheduler-date-label to">To</label>
              <div className="analyst-scheduler-date-input-wrapper">
                <input
                  type="text"
                  value={formatDateForDisplay(toDate)}
                  readOnly
                  disabled
                  className="analyst-scheduler-date-input-display"
                />
                <img
                  src={CalanderIcon}
                  alt="Calendar"
                  className="analyst-scheduler-calendar-icon"
                />
                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="analyst-scheduler-date-input-hidden"
                  min={fromDate}
                  disabled
                />
              </div>
            </div>
            <Button
              variant='outlined'
              onClick={handleSearch}
            >
              Search
            </Button>
          </div>
          <div className="analyst-scheduler-header-controls-right">
            <span className="analyst-scheduler-status-indicator">
              <span className="analyst-scheduler-status-dot green"></span>Due{' '}
              {">"} 10
            </span>
            <span className="analyst-scheduler-status-indicator">
              <span className="analyst-scheduler-status-dot red"></span>Due{' '}
              {">"} 14
            </span>
          </div>
        </div>
        <div className="analyst-scheduler-main-content">
          <div className="analyst-scheduler-schedule-table">
            {renderWeekSchedule(week1Dates, 'Week 1')}
            {renderWeekSchedule(week2Dates, 'Week 2')}
          </div>
          <div className="analyst-scheduler-sample-list">
            <div className="analyst-scheduler-sample-list-header">
              <h3 className="analyst-scheduler-sample-list-title">
                Current Sample List
              </h3>
              <div className="analyst-scheduler-sample-list-subtitle">
                (Click on Product Type to Select)
              </div>
            </div>
            <div className="analyst-scheduler-sample-items-container">
              {currentSampleList.map((sample) => (
                <div
                  key={sample.id}
                  className="analyst-scheduler-sample-item"
                  onClick={() => openSamplePopup(sample)}
                >
                  <div className="analyst-scheduler-sample-id">
                    <div className="analyst-scheduler-sample-id-inner">
                      <span>{sample.name}</span>
                      <span
                        className={`analyst-scheduler-status-dot ${sample.status}`}
                      ></span>
                    </div>
                  </div>
                  <div className="analyst-scheduler-sample-details">
                    Assay ({sample.assayCount}) | ReAssay 1 (
                    {sample.reAssay1Count}) | ReAssay 2 ({sample.reAssay2Count})
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {showPopup && (
          <div className="analyst-scheduler-popup-overlay">
            <div className="analyst-scheduler-assignment-popup">
              <div className="analyst-scheduler-assignment-popup-header">
                <span className="analyst-scheduler-assignment-popup-title">
                  Product Type: {selectedProduct?.name}
                </span>
                <Button
                  className="analyst-scheduler-popup-close-button"
                  onClick={handlePopupClose}
                >
                  <img src={CloseIcon} alt="Close" />
                </Button>
              </div>
              <div className="analyst-scheduler-assignment-popup-content">
                <div className="analyst-scheduler-assignment-controls">
                  <div className="analyst-scheduler-control-group">
                    <label className="analyst-scheduler-control-label">
                      Select Analyst
                    </label>
                    <select
                      className="analyst-scheduler-control-select"
                      value={selectedAnalyst || ''}
                      onChange={handleAnalystSelection}
                      disabled={
                        window.location.pathname === '/analyst-scheduler'
                      }
                    >
                      <option value="">Select Analyst</option>
                      {analysts.map((analyst) => (
                        <option
                          key={analyst.userID || analyst.userId || analyst.id}
                          value={String(
                            analyst.userID || analyst.userId || analyst.id
                          )}
                        >
                          {analyst.fullName || analyst.name || analyst.userName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="analyst-scheduler-control-group">
                    <label className="analyst-scheduler-control-label">
                      Select Date
                    </label>
                    <div className="analyst-scheduler-date-input-wrapper">
                      <input
                        type="text"
                        value={
                          selectedDate ? formatDateForDisplay(selectedDate) : ''
                        }
                        readOnly
                        className="analyst-scheduler-control-date-input"
                        placeholder="Select date"
                      />
                      <img
                        src={CalanderIcon}
                        alt="Calendar"
                        className="analyst-scheduler-calendar-icon"
                      />
                      <input
                        type="date"
                        value={selectedDate || ''}
                        onChange={handleDateSelection}
                        className="analyst-scheduler-date-input-hidden"
                        min={getTodayDateString()}
                      />
                    </div>
                  </div>
                  <div className="analyst-scheduler-control-group">
                    <label className="analyst-scheduler-control-label">
                      Assigned Product(s)
                    </label>
                    <div className="analyst-scheduler-assigned-products horizontal-scroll">
                      {assignedProductsFromSchedule &&
                        assignedProductsFromSchedule.length > 0 ? (
                        <div className="analyst-scheduler-assigned-products-list">
                          {assignedProductsFromSchedule.map(
                            (product, index) => (
                              <span
                                key={index}
                                className="analyst-scheduler-assigned-product-item"
                              >
                                {product.displayText ||
                                  product.productWithSampleCount ||
                                  `${product.productTypeName ||
                                  product.name ||
                                  'Unknown'
                                  }(${product.count || product.productCount || 0
                                  })`}
                                {index < assignedProductsFromSchedule.length - 1
                                  ? ', '
                                  : ''}
                              </span>
                            )
                          )}
                        </div>
                      ) : (
                        <span className="analyst-scheduler-no-assigned-products">
                          NIL
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="analyst-scheduler-samples-section">
                  <h4 className="analyst-scheduler-samples-title">
                    Select Samples to Assign
                  </h4>
                  <div className="analyst-scheduler-samples-table-container">
                    {productSamplesLoading ? (
                      <div>Loading...</div>
                    ) : (
                      <table className="analyst-scheduler-samples-table">
                        <thead className="analyst-scheduler-samples-table-header">
                          <tr>
                            <th className="analyst-scheduler-samples-table-th">
                              <input
                                type="checkbox"
                                className="analyst-scheduler-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedSamples(
                                      productSamples.map(
                                        (sample) => sample.sampleId
                                      )
                                    );
                                  } else {
                                    setSelectedSamples([]);
                                  }
                                }}
                                checked={
                                  selectedSamples.length ===
                                  productSamples.length &&
                                  productSamples.length > 0
                                }
                              />
                            </th>
                            <th className="analyst-scheduler-samples-table-th">
                              Sample ID
                            </th>
                            <th className="analyst-scheduler-samples-table-th">
                              Product
                            </th>
                            <th className="analyst-scheduler-samples-table-th">
                              Company
                            </th>
                            <th className="analyst-scheduler-samples-table-th">
                              Date
                            </th>
                            <th className="analyst-scheduler-samples-table-th">
                              Unit
                            </th>
                            <th className="analyst-scheduler-samples-table-th">
                              Exp Level
                            </th>
                            <th className="analyst-scheduler-samples-table-th">
                              Low Limit
                            </th>
                            <th className="analyst-scheduler-samples-table-th">
                              High Limit
                            </th>
                            <th className="analyst-scheduler-samples-table-th">
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {productSamples.map((sample) => (
                            <tr
                              key={sample.sampleId}
                              className={`analyst-scheduler-samples-table-row ${selectedSamples.includes(sample.sampleId)
                                ? 'selected'
                                : ''
                                }`}
                            >
                              <td className="analyst-scheduler-samples-table-td">
                                <input
                                  type="checkbox"
                                  className="analyst-scheduler-checkbox"
                                  checked={selectedSamples.includes(
                                    sample.sampleId
                                  )}
                                  onChange={() => {
                                    setSelectedSamples((prev) =>
                                      prev.includes(sample.sampleId)
                                        ? prev.filter(
                                          (id) => id !== sample.sampleId
                                        )
                                        : [...prev, sample.sampleId]
                                    );
                                  }}
                                />
                              </td>
                              <td className="analyst-scheduler-samples-table-td">
                                {sample.sampleId}
                              </td>
                              <td className="analyst-scheduler-samples-table-td">
                                {sample.productName}
                              </td>
                              <td className="analyst-scheduler-samples-table-td">
                                {sample.companyName}
                              </td>
                              <td className="analyst-scheduler-samples-table-td">
                                {sample.date
                                  ? formatDateDDMMYY(sample.date)
                                  : ''}
                              </td>
                              <td className="analyst-scheduler-samples-table-td">
                                {sample.unit}
                              </td>
                              <td className="analyst-scheduler-samples-table-td">
                                {sample.expectedLevel}
                              </td>
                              <td className="analyst-scheduler-samples-table-td">
                                {sample.lowLimit}
                              </td>
                              <td className="analyst-scheduler-samples-table-td">
                                {sample.highLimit}
                              </td>
                              <td className="analyst-scheduler-samples-table-td">
                                {sample.status}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="analyst-scheduler-popup-footer">
                    <Button
                      variant='outlined'
                      onClick={handlePopupClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant='contained'
                      onClick={handleAssign}
                    >
                      Assign
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showDeleteConfirm && (
          <div className="analyst-scheduler-popup-overlay analyst-scheduler-delete-popup-overlay">
            <div className="analyst-scheduler-delete-popup">
              <div className="analyst-scheduler-delete-popup-header">
                <span className="analyst-scheduler-delete-popup-title">
                  Remove Assigned Samples
                </span>
                <button
                  className="analyst-scheduler-popup-close-button"
                  onClick={() => {
                    setShowDeleteConfirm(false);
                    setSelectedSamplesToDelete([]);
                    setSamplesForRemove([]);
                  }}
                >
                  <img src={CloseIcon} alt="Close" />
                </button>
              </div>
              <div className="analyst-scheduler-delete-popup-content">
                <div className="analyst-scheduler-delete-message">
                  Select samples to remove:
                </div>
                <div className="analyst-scheduler-delete-samples-list">
                  <div className="analyst-scheduler-delete-samples-header">
                    <input
                      type="checkbox"
                      className="analyst-scheduler-checkbox"
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedSamplesToDelete(samplesForRemove.map(sample => sample.sampleId));
                        } else {
                          setSelectedSamplesToDelete([]);
                        }
                      }}
                      checked={
                        selectedSamplesToDelete.length === samplesForRemove.length &&
                        samplesForRemove.length > 0
                      }
                    />
                    <span>Sample ID</span>
                    <span>Product Name</span>
                  </div>
                  <div className="analyst-scheduler-delete-samples-container">
                    {samplesForRemove.map((sample, index) => (
                      <div key={index} className="analyst-scheduler-delete-sample-item">
                        <input
                          type="checkbox"
                          className="analyst-scheduler-checkbox"
                          checked={selectedSamplesToDelete.includes(sample.sampleId)}
                          onChange={() => {
                            setSelectedSamplesToDelete((prev) =>
                              prev.includes(sample.sampleId)
                                ? prev.filter((id) => id !== sample.sampleId)
                                : [...prev, sample.sampleId]
                            );
                          }}
                        />
                        <span className="analyst-scheduler-sample-id-text">{sample.sampleId}</span>
                        <span className="analyst-scheduler-sample-product-text">{sample.productName}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="analyst-scheduler-delete-popup-footer">
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setShowDeleteConfirm(false);
                      setSelectedSamplesToDelete([]);
                      setSamplesForRemove([]);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleConfirmDelete}
                    disabled={selectedSamplesToDelete.length === 0}
                  >
                    Remove
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AnalystScheduler;
